export default __webpack_public_path__ + "static/lshape-hero-a685131c298e71057a697da86d8cc15e.png";